import { IToastTaskOptions } from 'utils/toast/toast-task';
import { FC, ReactNode } from 'react';
import cx from 'classnames';

export interface IToastTaskProps extends IToastTaskOptions {
	message: ReactNode;
}

export const ToastTask: FC<IToastTaskProps> = ({
	name,
	message,
	percent,
	toastId,
	failed,
	done,
}) => {
	return (
		<div
			className={cx('toast-task', {
				done,
				failed,
			})}
			data-task-id={toastId}
		>
			<div className="toast-task__progress">
				{typeof percent === 'number' && (
					<span className="toast-task__progress-percent">{percent}%</span>
				)}
			</div>
			<div className="toast-task__content">
				{name && <span className="toast-task__content-name">{name}</span>}
				<span className="toast-task__content-message">{message}</span>
			</div>
		</div>
	);
};
